<template>
  <div>
    <g-header></g-header>
    <Rules v-if="RULES_POPUP_STATE"></Rules>
    <router-view></router-view>
    <g-footer></g-footer>
    <login-mask></login-mask>
    <loading-mask></loading-mask>
    <share-mask></share-mask>
  </div>
</template>

<script>
import GHeader from "@/components/Header";
import GFooter from "@/components/Footer";
import LoginMask from "@/components/LoginMask";
import LoadingMask from "@/components/LoadingMask";
import ShareMask from "@/components/ShareMask";
import Rules from "@/components/RulesPopup";

import { mapState } from "vuex";
export default {
  name: "layout",

  components: {
    GHeader,
    GFooter,
    LoginMask,
    LoadingMask,
    ShareMask,
    Rules
  },
  data: () => ({}),
  created() {},
  mounted() {
    this.$utils.preload([
      {
        as: 'image',
        url: require("../assets/images/login/BG.png")
      },
      {
        as: 'image',
        url: require("../assets/images/vote_mask/vote_bg.png")
      }
    ])
  },
  watch: {},
  computed: {
    ...mapState({
      RULES_POPUP_STATE: (state) => state.Home.RULES_POPUP_STATE,
    }),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
